<template>
  <gs-wizard-step>
    <p-row>
      <p-col xs12 md9 lg6 xl5>
        <h5>{{ $t('memberPortal.classifyHotel.text.costs') }}</h5>
        <p>{{ $t('memberPortal.classifyHotel.text.classificationCostExplanation') }}</p>
        <p>{{ $t('memberPortal.classifyHotel.text.classificationCostTableHeader') }}</p>
        <p-table
          v-model="costEntriesMember"
          class="mb-4 mt-4"
          :columns="memberCostColumns"
        ></p-table>
        <p-table
          v-model="costEntriesNonMember"
          class="mb-4"
          :columns="nonMemberCostColumns"
        ></p-table>
        <p>{{ $t('memberPortal.classifyHotel.text.classificationIncludedItems') }}</p>

        <!--<gs-toggle-value
      v-model="innerValue.paymentMethod"
      class="mb-4"
      :label="$t('memberPortal.createMembership.label.paymentMethod')"
      :caption-one="$t('memberPortal.createMembership.label.online')"
      :caption-two="$t('memberPortal.createMembership.label.perBill')"
      :value-one="6"
      :value-two="1"
    ></gs-toggle-value>-->
        <p-alert class="mb-4" type="info" :value="true">
          <span class="mr-2">{{ $t('memberPortal.classifyHotel.alert.profitOfMembership') }}</span>
          <p-button @click="getMembership">
            {{ $t('memberPortal.classifyHotel.button.getMembership') }}
          </p-button>
        </p-alert>
        <p-checkbox v-slot="{ label, checked }" v-model="innerValue.acceptAgb" label="confirmDetails">
          <span>{{ $t('memberPortal.classifyHotel.text.confirmDetails') }}</span>

          <a target="_blank" :href="$t('links.hotelklassifikation')">{{ $t('memberPortal.classifyHotel.text.guidelines') }}</a>
          <span>{{ $t('memberPortal.classifyHotel.text.agree') }}</span>
        </p-checkbox>
      </p-col>
    </p-row>
  </gs-wizard-step>
</template>

<script lang="ts">
  import CreateHotelClassificationRequestViewModel from '../../../../../services/v1/viewModel/resource/CreateHotelClassificationRequestViewModel';
  import Vue from 'vue';

  export default Vue.extend({
    auth: true,
    hasBackButton: true,
    props: {
      value: { type: Object, default: undefined },
    },
    data: () => ({
      costEntriesMember: [
        {
          caption: Vue.$t('memberPortal.classifyHotel.table.baseContribution'),
          oneStar: 100.00,
          twoStar: 150.00,
          threeStar: 200.00,
          fourStar: 250.00,
          fiveStar: 300.00,
        },
        {
          caption: Vue.$t('memberPortal.classifyHotel.table.roomContribution'),
          oneStar: 3.00,
          twoStar: 3.00,
          threeStar: 4.00,
          fourStar: 5.00,
          fiveStar: 5.00,
        },
      ],
      costEntriesNonMember: [
        {
          caption: Vue.$t('memberPortal.classifyHotel.table.baseContribution'),
          oneStar: 200.00,
          twoStar: 300.00,
          threeStar: 400.00,
          fourStar: 500.00,
          fiveStar: 600.00,
        },
        {
          caption: Vue.$t('memberPortal.classifyHotel.table.roomContribution'),
          oneStar: 3.00,
          twoStar: 3.00,
          threeStar: 4.00,
          fourStar: 5.00,
          fiveStar: 5.00,
        },
      ],
      memberCostColumns: [
        { value: Vue.$t('memberPortal.classifyHotel.table.memberCostTitle'), field: 'caption' },
        {
          width: '100px', textAlign: 'right', format: (data: number) => Vue.$format.currency(data, 'CHF'), value: '⭐', field: 'oneStar',
        },
        {
          width: '100px', textAlign: 'right', format: (data: number) => Vue.$format.currency(data, 'CHF'), value: '⭐⭐', field: 'twoStar',
        },
        {
          width: '100px', textAlign: 'right', format: (data: number) => Vue.$format.currency(data, 'CHF'), value: '⭐⭐⭐', field: 'threeStar',
        },
        {
          width: '100px', textAlign: 'right', format: (data: number) => Vue.$format.currency(data, 'CHF'), value: '⭐⭐⭐⭐', field: 'fourStar',
        },
        {
          width: '100px', textAlign: 'right', format: (data: number) => Vue.$format.currency(data, 'CHF'), value: '⭐⭐⭐⭐⭐', field: 'fiveStar',
        },
      ],
      nonMemberCostColumns: [
        { value: Vue.$t('memberPortal.classifyHotel.table.nonMemberCostTitle'), field: 'caption' },
        {
          width: '100px', textAlign: 'right', format: (data: number) => Vue.$format.currency(data, 'CHF'), value: '⭐', field: 'oneStar',
        },
        {
          width: '100px', textAlign: 'right', format: (data: number) => Vue.$format.currency(data, 'CHF'), value: '⭐⭐', field: 'twoStar',
        },
        {
          width: '100px', textAlign: 'right', format: (data: number) => Vue.$format.currency(data, 'CHF'), value: '⭐⭐⭐', field: 'threeStar',
        },
        {
          width: '100px', textAlign: 'right', format: (data: number) => Vue.$format.currency(data, 'CHF'), value: '⭐⭐⭐⭐', field: 'fourStar',
        },
        {
          width: '100px', textAlign: 'right', format: (data: number) => Vue.$format.currency(data, 'CHF'), value: '⭐⭐⭐⭐⭐', field: 'fiveStar',
        },
      ],
    }),
    computed: {
      innerValue: {
        get(): CreateHotelClassificationRequestViewModel {
          return this.value ?? {};
        },
        set(value: CreateHotelClassificationRequestViewModel) {
          this.$emit('input', value);
        },
      },
    },
    methods: {
      getMembership() {
        this.$router.push('/gs/memberPortal/member-data', () => {});
      },
    },
  });
</script>
